var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.signConfiguration.certificado
      ? _c("div", [
          _vm.ambit === _vm.ambits.profile
            ? _c("div", [
                _c("h3", [_vm._v("¿Por qué no tienes certificado?")]),
                _vm._v(" Para comenzar a operar con "),
                _c("b", [_vm._v("Firma Simple")]),
                _vm._v(", primero debemos crearte un "),
                _c("b", [_vm._v("Certificado Digital")]),
                _vm._v(
                  ", es como tu firma en papel, pero ahora será electrónica, y mucho más segura. Antes de poder generarte el certificado digital, primero debemos asegurarnos de que tu perfil se encuentra configurado correctamente, para ello es necesario que revises si ya se ha configurado tu "
                ),
                _c("b", [_vm._v("cargo")]),
                _vm._v(" actual así como la "),
                _c("b", [_vm._v("gerencia o departamento")]),
                _vm._v(
                  " al que perteneces, ya que tu firma incluirá dicha información. "
                ),
                _c("br"),
                _c("br"),
                _vm._m(0),
                _c("br"),
                _c("br"),
                _vm._v(
                  " Junto con esto, comunícate con tu administrador de sistema para que te habilite tu certificado "
                )
              ])
            : _c(
                "div",
                [
                  _vm.showConfig
                    ? _c("ActiveSign", {
                        attrs: {
                          configurations: _vm.signConfiguration,
                          user: _vm.signConfiguration.usuario
                        },
                        on: { activate: _vm.activate }
                      })
                    : _vm._e()
                ],
                1
              )
        ])
      : _vm._e(),
    _vm.signConfiguration.certificado
      ? _c("div", [
          _c("div", { staticClass: "row justify-content-center" }, [
            _c(
              "div",
              { staticClass: "col-lg-6 col-md-12 col-sm-12 col-12" },
              [
                _c("h4", [_vm._v("Certificado digital")]),
                _c("SignCard", {
                  attrs: {
                    user: _vm.signConfiguration.usuario,
                    company: _vm.company,
                    certificate: _vm.certificate
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "divider" }),
          _vm.ambit === _vm.ambits.profile
            ? _c(
                "div",
                [
                  _vm.showConfig
                    ? _c("ConfigureSign", {
                        attrs: {
                          user: _vm.signConfiguration.usuario,
                          configurations: _vm.configurations
                        }
                      })
                    : _vm._e(),
                  _c("br"),
                  _vm.showPdf
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 container-pdf" },
                          _vm._l(_vm.numPages, function(i) {
                            return _c("pdf", {
                              key: i,
                              attrs: { src: _vm.url, page: i }
                            })
                          }),
                          1
                        ),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12 form-group" }, [
                              _c("label", { attrs: { for: "otp" } }, [
                                _vm._v("Código OTP")
                              ]),
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "numeric|required|min:4|max:6",
                                    expression: "'numeric|required|min:4|max:6'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.otp,
                                    expression: "otp"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  name: "otp",
                                  id: "otp",
                                  maxlength: "6",
                                  placeholder: "OTP",
                                  size: "small"
                                },
                                domProps: { value: _vm.otp },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.otp = $event.target.value
                                  }
                                }
                              }),
                              _c(
                                "small",
                                {
                                  staticClass: "form-text text-muted",
                                  attrs: { id: "otpHelp" }
                                },
                                [
                                  _vm._v(
                                    " * Son los seis números que te muestra el Google Authenticator. "
                                  )
                                ]
                              ),
                              _vm.errors.has("otp")
                                ? _c(
                                    "small",
                                    {
                                      staticClass: "form-text text-danger",
                                      attrs: { id: "otpError" }
                                    },
                                    [
                                      _vm._v(
                                        " *" +
                                          _vm._s(_vm.errors.first("otp")) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm.sendingSign
                            ? _c(
                                "div",
                                { staticClass: "row" },
                                [
                                  _c("b-spinner", {
                                    attrs: { small: "", variant: "primary" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.sendingSign
                            ? _c("div", { staticClass: "row mb-2" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.confirmationRead,
                                            expression: "confirmationRead"
                                          }
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: "checkConfirmationRead"
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.confirmationRead
                                          )
                                            ? _vm._i(
                                                _vm.confirmationRead,
                                                null
                                              ) > -1
                                            : _vm.confirmationRead
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.confirmationRead,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.confirmationRead = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.confirmationRead = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.confirmationRead = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: {
                                            for: "checkConfirmationRead"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " HE LEÍDO Y ACEPTO LAS CONDICIONES "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          !_vm.sendingSign
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "row justify-content-end text-right"
                                },
                                [
                                  _c("div", { staticClass: "col-md-5" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-info ",
                                        attrs: { type: "button" },
                                        on: { click: _vm.changeToConfig }
                                      },
                                      [_vm._v(" Volver a Configuración ")]
                                    )
                                  ]),
                                  _c("div", { staticClass: "col-md-7" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        attrs: {
                                          type: "button",
                                          disabled: !_vm.confirmationRead
                                        },
                                        on: { click: _vm.signAndConfigure }
                                      },
                                      [_vm._v(" Firmar Responsabilidad ")]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm.certificate.estado === _vm.certStatus.CREATE
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row d-flex justify-content-end text-right"
                        },
                        [
                          _vm.showConfig
                            ? _c("div", { staticClass: "col-md-6" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: { type: "button" },
                                    on: { click: _vm.changeToPdf }
                                  },
                                  [_vm._v(" Leer responsabilidad ")]
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm.certificate.estado === _vm.certStatus.ACTIVE
                    ? _c(
                        "div",
                        {
                          staticClass: "row row justify-content-end text-right"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col align-self-end" },
                            [
                              !_vm.savingConfig
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: { type: "button" },
                                      on: { click: _vm.saveConfiguration }
                                    },
                                    [_vm._v(" Guardar configuración ")]
                                  )
                                : _vm._e(),
                              _vm.savingConfig
                                ? _c("b-spinner", {
                                    attrs: { small: "", variant: "primary" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { attrs: { "ng-if": "!datos.parametros.usuario.otpId" } }, [
      _vm._v(
        " Además de que tus datos estén correctamente configurados, necesitaremos que configures "
      ),
      _c("b", [_vm._v("2FA")]),
      _vm._v(", para dar mayor seguridad al proceso. ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }